export default "__VITE_ASSET__CRfhM4pd__"